module.exports = __webpack_public_path__ + "img/jim-anderson.8c15be0e.png";